export var labelMargin = '4px 0 0 0';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/constants.js
// module id = 341
// module chunks = 0